import { JillFisher } from "../../../../src/components/JillFisher";
import * as React from 'react';
export default {
  JillFisher,
  React
};